import { Input } from "antd";

import type { AvE2EProps } from "@av/components/types";

import type { PasswordProps as AntdPasswordProps } from "antd/es/input";

type PasswordProps = AntdPasswordProps & AvE2EProps;

export function CustomPassword(props: PasswordProps) {
  const { testIdPrefix, "data-testId": dataTestIdProp, ...rest } = props;

  const dataTestId = dataTestIdProp ?? `${testIdPrefix}-password-input`;

  return <Input.Password data-testid={dataTestId} {...rest} />;
}
